import {
  CARE_LEVELS,
  DRV_TRAVEL_TYPES,
  OUTPATIENT_NOT_POSSIBLE_REASONS,
  REHAB_TRIGGERING_EVENT,
} from "core/consts";
import {
  DRG_CODE_CHARACTER_LIMIT,
  ICD_CODE_CHARACTER_LIMIT,
  IK_NUMBER_CHARACTER_LIMIT,
  INFECTIONS_CHARACTER_LIMIT,
  PENSION_INSURANCE_NUMBER_CHARACTER_LIMIT,
  predicamentSchema,
} from "core/schemas/shared";
import { z } from "zod";

export const DRVMedicalFormSchema = z.object({
  admission_date: z.number().optional(),
  carelevel: z.nativeEnum(CARE_LEVELS).optional(),
  carelevel_selected: predicamentSchema.nullish().optional(),
  clinical_findings: z.string().optional(),
  complications: z.string().optional(),
  current_therapy: z.string().optional(),
  day_reha: z.boolean().optional(),
  discharge_date: z.number().optional(),
  drg_code: z.string().max(DRG_CODE_CHARACTER_LIMIT).optional(),
  drv_remarks: z.string().optional(),
  eat_without_help: predicamentSchema.nullish().optional(),
  fecal_incontinence: predicamentSchema.nullish().optional(),
  full_reha: z.boolean().optional(),
  further_therapeutic_diagnostic_measures_description: z.string().optional(),
  further_therapeutic_diagnostic_measures_finished_on: z.number().optional(),
  further_therapeutic_diagnostic_measures_from: z.number().optional(),
  further_therapeutic_diagnostic_measures_to: z.number().optional(),
  hospital_bank_holder: z.string().optional(),
  hospital_bank_name: z.string().optional(),
  hospital_billing_address: z.string().optional(),
  hospital_iban: z.string().optional(),
  hospital_ik_number: z.string().max(IK_NUMBER_CHARACTER_LIMIT).optional(),
  hospital_name_address: z.string().optional(),
  icd_code_1_code: z.string().max(ICD_CODE_CHARACTER_LIMIT).optional(),
  icd_code_2_code: z.string().max(ICD_CODE_CHARACTER_LIMIT).optional(),
  icd_code_3_code: z.string().max(ICD_CODE_CHARACTER_LIMIT).optional(),
  infections: z.string().max(INFECTIONS_CHARACTER_LIMIT).optional(),
  infections_selected: predicamentSchema.nullish().optional(),
  insurance_delivery_address: z.string().optional(),
  main_diagnosis: z.string().optional(),
  mobility_walk_without_help: predicamentSchema.nullish().optional(),
  mobility_wheel_chair: predicamentSchema.nullish().optional(),
  needs_catheter: z.string().optional(),
  needs_catheter_selected: predicamentSchema.nullish().optional(),
  orientation_disoriented: z.string().optional(),
  orientation_disoriented_selected: predicamentSchema.nullish().optional(),
  other_measures: predicamentSchema.nullish().optional(),
  outpatient_not_possible_reason: z
    .array(z.nativeEnum(OUTPATIENT_NOT_POSSIBLE_REASONS))
    .optional(),
  patient_birthdate: z.number().optional(),
  patient_city: z.string().optional(),
  patient_height: z.string().optional(),
  patient_name: z.string().optional(),
  patient_street_housenumber: z.string().optional(),
  patient_weight: z.string().optional(),
  patient_zipcode: z.string().optional(),
  pension_procedure_after_examination: z.boolean().optional(),
  pension_procedure_direct: z.boolean().optional(),
  preferred_rehab_clinic: z.string().optional(),
  rehab_triggering_event: z
    .array(z.nativeEnum(REHAB_TRIGGERING_EVENT))
    .optional(),
  rehab_triggering_event_date: z.number().optional(),
  secondary_diagnosis: z.string().optional(),
  secondary_diagnosis_selected: predicamentSchema.nullish().optional(),
  social_worker_name_number: z.string().optional(),
  statutory_pension_insurance_number: z
    .string()
    .max(PENSION_INSURANCE_NUMBER_CHARACTER_LIMIT)
    .optional(),
  transfer_date: z.number().optional(),
  transport_type: z.array(z.nativeEnum(DRV_TRAVEL_TYPES)).optional(),
  urinary_incontinence: predicamentSchema.nullish().optional(),
  wash_and_dress_without_help: predicamentSchema.nullish().optional(),
  wound_closed: predicamentSchema.nullish().optional(),
});
